// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__QmhRO","inner":"Accordion_inner__I2ChW","active":"Accordion_active__VHGYt","icon":"Accordion_icon__kZj3c","content":"Accordion_content__MjnLL"};